/* eslint-disable jsx-a11y/anchor-is-valid */
import classnames from 'classnames'
import Link from 'next/link'
import { useRouter } from 'next/router'
import styles from './NavItem.module.css'

export type NavItemProps = {
    href: string
    label: string
    badgeNumber?: number | null
    faicon?: string | null
    closeNav: any
}

export const NavItem = ({ href, label, faicon, closeNav }: NavItemProps) => {
    const router = useRouter()
    const active =
        href !== '/' ? router?.pathname?.includes(href) : router?.pathname === href
    const clsx = classnames(
        'bg-white',
        'pt-5',
        'pb-5',
        'pl-7',
        'flex',
        'items-center',
        'cursor-pointer',
        'relative',
        'fill-current',
        'font-normal',
        'transition-all',
        'hover:text-yf-purple',
        {
            'text-gray-500': !active,
            'text-yf-purple': active,
            'bg-yf-purple-300': active,
            'font-medium': active,
            'hover:bg-gray-100': !active,
            [styles.navitemactive]: active,
            [styles.naviteminactive]: !active
        }
    )

    return (
        <li>
            <Link href={href} prefetch={false}>
                <a className={clsx} onClick={closeNav}>
                    <span className="w-5 h-5 text-xl leading-none mr-7 text-right">
                        <i aria-hidden className={`${faicon}`}></i>
                    </span>
                    <p className="text-lg">{label}</p>
                </a>
            </Link>
        </li>
    )
}
